import {
  Component,
  inject,
  OnInit,
  ChangeDetectorRef,
  HostListener,
  ElementRef,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Api } from '../../services/api';
import { MdlCall } from '../../components/mdl-call/mdl-call';
import { MdlTask } from '../../components/mdl-task/mdl-task';
import { MdlEvent } from '../../components/mdl-event/mdl-event';
import { CommonModule } from '@angular/common';
import { Mdlfilterectivities } from '../../components/mdl-filter-activities/mdl-filter-activities';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { ActivatedRoute, Router } from '@angular/router';
import { MdlDelete } from '../../components/mdl-delete/mdl-delete';
import { NavContact } from '../../components/contact/nav-contact/nav-contact';
import { MdlChangeContact } from '../../components/mdl-change-contact/mdl-change-contact';
import { AlertService } from '../../services/alert.service';
import { NavBudget } from '../../components/budget/nav-budget/nav-budget';
import { PermissionService } from '../../services/permission.service';
import { MdlManageBudget } from '../../components/mdl-manage-budget/mdl-manage-budget';
import { MdlNewTaskComponent } from '../../components/mdl-new-task/mdl-new-task';
import { FormsModule } from '@angular/forms';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { MdlManageContact } from '../../components/mdl-manage-contact/mdl-manage-contact';
import { MdlManageProspect } from '../../components/mdl-manage-prospect/mdl-manage-prospect';
import { MdlSendMail } from '../../components/mdl-send-mail/mdl-send-mail';
import { MdlNewEventComponent } from '../../components/mdl-new-event/mdl-new-event';
import { NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';


@Component({
  selector: 'app-budget-detail',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatSelectModule,
    MatButtonModule,
    MatDividerModule,
    NavBudget,
    FormsModule,
  ],
  templateUrl: './budget-detail.html',
  styleUrl: './budget-detail.css',
})
export class BudgetDetail implements OnInit {
  public presupuesto: any = null;
  public api = inject(Api);
  public isLoading: boolean = true;
  public errorMessage: string = '';
  public presupuesto_id: string = '';
  public progreso_estado: any = [];
  public markedStatus: string = '';
  public showBudgetInfoSection: boolean = true;
  public showInfoSection: boolean = true;
  public showExtraSection: boolean = true;
  public showTotalsSection: boolean = true;
  public showPreparedSection: boolean = true;
  public showShippingSection: boolean = true;
  public showHistorySection: boolean = true;

  public editBudgetInfo: boolean = false;
  public editInfo: boolean = false;
  public editExtra: boolean = false;
  public editTotals: boolean = false;
  public editShipping: boolean = false;

  public editableBudget: any = {};

  readonly dialog = inject(MatDialog);

  openedMenuId: string | null = null;
  showRecentDropdown: boolean = false;

  constructor(
    private cdr: ChangeDetectorRef,
    private route: ActivatedRoute,
    private elementRef: ElementRef,
    private alertService: AlertService,
    public permissionService: PermissionService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.presupuesto_id = params['id'];
      if (this.presupuesto_id) {
        this.loadBudget(this.presupuesto_id);
      } else {
        this.errorMessage = 'No se proporcionó un ID de presupuesto válido';
        this.isLoading = false;
      }
    });
    this.router.events
  .pipe(filter((e) => e instanceof NavigationEnd))
  .subscribe(() => {
    if (this.presupuesto_id) {
      this.loadBudget(this.presupuesto_id);
    }
  });

  }

  @HostListener('document:click', ['$event.target'])
  onClickOutside(target: EventTarget | null): void {
    if (!(target instanceof HTMLElement)) return;

    const clickedInsideRecent = this.elementRef.nativeElement
      .querySelector('.dropdown-trigger')
      ?.contains(target);
    const clickedInsideActions = this.elementRef.nativeElement
      .querySelector('.dots-button')
      ?.contains(target);

    if (!clickedInsideRecent) {
      this.showRecentDropdown = false;
    }

    if (!clickedInsideActions) {
      this.openedMenuId = null;
    }
  }

  loadBudget(id: string): void {
    console.log('Iniciando carga de presupuesto, ID:', id);
    this.isLoading = true;
    this.errorMessage = '';

    this.api.getBudgetById(id).subscribe({
      next: (response: any) => {
        this.isLoading = false;
        if (response?.presupuesto) {
          this.presupuesto = response.presupuesto;
          // Cargar los estados de progreso si vienen en la respuesta
          if (response.progreso_estados) {
            this.progreso_estado = response.progreso_estados;
            console.log('Estados de progreso cargados:', this.progreso_estado);
          }
        } else {
          this.errorMessage =
            response?.message || 'No se encontraron datos del presupuesto';
        }
        this.cdr.detectChanges();
      },
      error: (err: any) => {
        console.error('Error en API:', err);

        if (err.status === 403) {
          this.errorMessage = 'No tienes permiso para ver este presupuesto.';
          this.router.navigateByUrl('/budget');
        } else {
          this.errorMessage = 'Error al cargar el presupuesto.';
        }

        this.isLoading = false;
        this.api.hideLoading();
      },
    });
  }

  updateBudget(data: any) {
    console.log('Click');
    this.dialog
      .open(MdlManageBudget, {
        minWidth: '800px',
        maxHeight: '900px',
        panelClass: 'mat-dlg-class',
        data: {
          mode: 'edit',
          budget: data,
        },
      })
      .afterClosed()
      .subscribe((result) => {
        if (result) {
          this.loadBudget(this.presupuesto_id);
        }
      });
  }

  openNewCall(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.presupuesto,
        tipo: 'PRE',
        mode: 'call',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openMdlCreateContact() {
          this.dialog.open(MdlManageContact,{
              minWidth: '800px',
              maxHeight: '900px',
              panelClass: 'mat-dlg-class',
              data:{
                  mode: 'create'
              }
          });
      }

     openMdlCreateProspect(){
       this.dialog.open(MdlManageProspect,{
         minWidth: '800px',
         maxHeight: '900px',
         panelClass: 'mat-dlg-class',
         data:{
           mode: 'create'
         }});
     }   

  openNewTask(): void {
    this.dialog.open(MdlNewTaskComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.presupuesto,
        mode: 'task',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewEvent(): void {
    this.dialog.open(MdlNewEventComponent, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
      data: {
        entidad: this.presupuesto,
        mode: 'event',
      },
    }).afterClosed().subscribe(result =>{
      if (result){
       window.location.reload() 
      }
    })
  }

  openNewfilterActivities(): void {
    this.dialog.open(Mdlfilterectivities, {
      minWidth: '650px',
      maxHeight: '900px',
      panelClass: 'mat-dlg-class',
    });
  }

  toggleActionsMenu(id: string): void {
    this.openedMenuId = this.openedMenuId === id ? null : id;
    this.showRecentDropdown = false;
  }

  openMdlDeleteBudget(): void {
    if (!this.presupuesto_id) return;

    this.dialog.open(MdlDelete, {
      minWidth: '500px',
      minHeight: '260px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'budget',
        id: this.presupuesto_id,
      },
    });
  }

  markStatus(status: string) {
    if (this.markedStatus === status) {
      this.markedStatus = '';
    } else {
      this.markedStatus = status;
    }
    console.log('Estado marcado:', this.markedStatus);
  }

  updateBudgetStatus() {
    const data = {
      presupuesto_id: this.presupuesto_id,
      id_estado: this.markedStatus,
    };
    console.log('Datos para actualizar estado:', data);

    this.api.updateBudgetStatus(data).subscribe({
      next: (data: any) => {
        console.log(data);
        this.loadBudget(this.presupuesto_id);
      },
      error: (err: any) => {
        this.api.hideLoading();
        if (err.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para cambiar el estado')
          return
        }
        this.alertService.error('Error','Ocurrio un error inesperados')
      },
    });
  }

  toggleSection(section: string) {
    switch (section) {
      case 'budgetInfo':
        this.showBudgetInfoSection = !this.showBudgetInfoSection;
        break;
      case 'info':
        this.showInfoSection = !this.showInfoSection;
        break;
      case 'extra':
        this.showExtraSection = !this.showExtraSection;
        break;
      case 'totals':
        this.showTotalsSection = !this.showTotalsSection;
        break;
      case 'prepared':
        this.showPreparedSection = !this.showPreparedSection;
        break;
      case 'shipping':
        this.showShippingSection = !this.showShippingSection;
        break;
      case 'history':
        this.showHistorySection = !this.showHistorySection;
        break;
    }
  }

  toggleEdit(section: 'info' | 'extra' | 'totals' | 'budgetInfo' | 'shipping') {
    switch (section) {
      case 'budgetInfo':
        this.editBudgetInfo = !this.editBudgetInfo;
        break;
      case 'info':
        this.editInfo = !this.editInfo;
        break;
      case 'extra':
        this.editExtra = !this.editExtra;
        break;
      case 'totals':
        this.editTotals = !this.editTotals;
        break;
      case 'shipping':
        this.editShipping = !this.editShipping;
        break;
    }

    if (
      this.editInfo ||
      this.editExtra ||
      this.editTotals ||
      this.editShipping
    ) {
      this.editableBudget = { ...this.presupuesto };
    }
  }

  cancelEdit(section: 'info' | 'extra' | 'totals' | 'budgetInfo' | 'shipping') {
    if (section === 'budgetInfo') this.editBudgetInfo = false;
    if (section === 'info') this.editInfo = false;
    if (section === 'extra') this.editExtra = false;
    if (section === 'totals') this.editTotals = false;
    if (section === 'shipping') this.editShipping = false;
    this.editableBudget = { ...this.presupuesto };
  }

saveSection(
    section: 'info' | 'extra' | 'totals' | 'budgetInfo' | 'shipping'
  ) {
    this.api.updateBudget(this.editableBudget).subscribe({
      next: (resp: any) => {
        this.alertService.success('Actualización exitosa', 'Presupuesto actualizado correctamente');

        if (resp.presupuesto) {
          this.presupuesto = resp.presupuesto;
        } else {
          this.presupuesto = { ...this.editableBudget };
        }

        if (section === 'budgetInfo') this.editBudgetInfo = false;
        if (section === 'info') this.editInfo = false;
        if (section === 'extra') this.editExtra = false;
        if (section === 'totals') this.editTotals = false;
        if (section === 'shipping') this.editShipping = false;
      },
      error: (err) => {
        if (err?.status===403){
          this.alertService.error('Acceso denegado','No tienes permiso para editar')
        }
        this.alertService.error('Error al actualizar', 'Error al actualizar presupuesto');
      },
    });
  }

  generarPDF() {
    const p = this.presupuesto;
    if (!p) return;

    const doc = new jsPDF('p', 'mm', 'a4');
    const colorOrg: [number, number, number] = [230, 90, 20];
    const colorGray: [number, number, number] = [80, 80, 80];
    const margenX = 20;
    let y = 20;

    // === LOGO ===
    try {
      const logo = new Image();
      logo.src = 'assets/img/logo.png';
      doc.addImage(logo, 'PNG', margenX, 15, 38, 15);
    } catch {
      console.warn('⚠️ No se pudo cargar el logo');
    }

    // === TÍTULO ===
    doc.setFontSize(18);
    doc.setTextColor(colorOrg[0], colorOrg[1], colorOrg[2]);
    doc.text('PRESUPUESTO', 190 - margenX, 25, { align: 'right' });
    doc.setDrawColor(colorOrg[0], colorOrg[1], colorOrg[2]);
    doc.setLineWidth(0.8);
    doc.line(135, 27, 190 - margenX, 27);

    // === DATOS DERECHA (CORREGIDO Y ALINEADO) ===
    doc.setFontSize(10);
    doc.setTextColor(0, 0, 0);

    let rightY = 35;
    const labelX = 130;
    const valueX = 185;
    const lineSpacing = 8; // más separación

    // Helper para imprimir par label + valor alineado
    function printRow(label: string, value: string) {
      doc.text(label, labelX, rightY);
      doc.text(value || '-', valueX, rightY, { align: 'right' });
      rightY += lineSpacing;
    }

    // Datos
    printRow('Número presupuesto:', p.numero_presupuesto || '-');
    printRow(
      'Fecha presupuesto:',
      new Date(p.fecha_creacion!).toLocaleDateString('es-CL')
    );
    printRow(
      'Fecha caducidad:',
      new Date(p.fecha_caducidad!).toLocaleDateString('es-CL')
    );

    // === DATOS EMPRESA ===
    y = 40;
    doc.setFontSize(10);
    doc.text('TIC Services SPA', margenX, y);
    y += 5;
    doc.text('RUT: 76.423.634-3', margenX, y);
    y += 5;
    doc.text(
      'Av. del Parque 4928, Of 224, Huechuraba, Región Metropolitana.',
      margenX,
      y
    );

// === INFO COMPRADOR Y PREPARADO POR ===
y += 15;
doc.setFontSize(12);
doc.setTextColor(colorOrg[0], colorOrg[1], colorOrg[2]);
doc.text('Información comprador:', margenX, y);
doc.text('Preparado por:', 120, y);
y += 6;

doc.setFontSize(10);
doc.setTextColor(0, 0, 0);

const cuenta = p.contacto?.cuenta;
const comprador = cuenta?.nombre_empresa || '-';
const rut = cuenta?.rut || '-';
const direccion = cuenta?.direccion_env || '-';
const ejecutivo = p.ejecutivo || {};

const lineH = 5;

// ancho real de la columna izquierda (en mm)
const leftColWidth = 85;

// wrap automático por palabras según ancho real
function wrapByWidth(text: string, maxWidth: number) {
  const words = text.split(' ');
  const lines: string[] = [];
  let line = '';

  for (const w of words) {
    const test = line ? `${line} ${w}` : w;
    if (doc.getTextWidth(test) <= maxWidth) {
      line = test;
    } else {
      if (line) lines.push(line);
      line = w;
    }
  }
  if (line) lines.push(line);
  return lines.length ? lines : ['-'];
}

// IZQUIERDA
const nombreLines = wrapByWidth(`Nombre empresa: ${comprador}`, leftColWidth);
nombreLines.forEach((line, idx) => {
  doc.text(line, margenX, y + idx * lineH);
});
let leftY = y + nombreLines.length * lineH;

doc.text(`RUT: ${rut}`, margenX, leftY);
leftY += lineH;

const direccionLines = wrapByWidth(`Dirección: ${direccion}`, leftColWidth);
direccionLines.forEach((line, idx) => {
  doc.text(line, margenX, leftY + idx * lineH);
});
leftY += direccionLines.length * lineH;

// DERECHA: misma altura inicial que la izquierda
let rightYBlock = y;
doc.text(`Nombre: ${ejecutivo.nombre || '-'}`, 120, rightYBlock);
rightYBlock += lineH;
doc.text(`Correo: ${ejecutivo.email || '-'}`, 120, rightYBlock);

// Actualizar y global
y = Math.max(leftY, rightYBlock) + 5;



    // === TABLA ===
    y += 10;
    // === AGRUPAR PRODUCTOS REPETIDOS ===
const agrupados = new Map<string, { cantidad: number; total: number; precio_unitario: number }>();

(p.presupuesto_item || []).forEach((item: any) => {
  const nombre = item.producto_servicio || '—';
  const cantidad = Number(item.cantidad || 1);
  const precio = Number(item.precio_unitario || 0);
  const subtotal = precio * cantidad;

  if (agrupados.has(nombre)) {
    const existente = agrupados.get(nombre)!;
    existente.cantidad += cantidad;
    existente.total += subtotal;
  } else {
    agrupados.set(nombre, {
      cantidad,
      total: subtotal,
      precio_unitario: precio,
    });
  }
});

// === CONVERTIR A ARRAY PARA autoTable ===
const productos = Array.from(agrupados.entries()).map(([nombre, data]) => [
  nombre,
  `$ ${data.precio_unitario.toLocaleString('es-CL')}`,
  data.cantidad,
  `$ ${data.total.toLocaleString('es-CL')}`,
]);


    autoTable(doc, {
      startY: y,
      head: [['Producto', 'Precio de venta', 'Cantidad', 'Precio Total']],
      body: productos,
      theme: 'grid',
      styles: {
        fontSize: 9,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.2,
      },
      headStyles: {
        fillColor: colorOrg,
        textColor: 255,
        halign: 'center',
        fontStyle: 'bold',
      },
      columnStyles: {
        0: { cellWidth: 80 },
        1: { halign: 'right' },
        2: { halign: 'center' },
        3: { halign: 'right' },
      },
    });

    const finalY = (doc as any).lastAutoTable.finalY + 10;

    // === TOTALES (CORREGIDO Y ALINEADO) ===
    const subtotal = Number(p.subtotal || 0);
    const impuestos = Number(p.impuestos || 0);
    const envio = Number(p.envio || 0);
    const descuento = Number(p.descuento_global || 0);
    const total = Number(p.precio_total || 0);
    const descuentoMonto = subtotal * (descuento / 100);

    let lineY = finalY + 6; // más aire antes del bloque
    const labelTotX = 130;
    const valueTotX = 185; // más a la izquierda para evitar superposición

    doc.setFontSize(11);
    doc.setTextColor(60, 60, 60);

    // Helper para imprimir filas de totales
    function printTotalRow(label: string, value: string) {
      doc.text(label, labelTotX, lineY);
      doc.text(value, valueTotX, lineY, { align: 'right' });
      lineY += lineSpacing;
    }

    // Fila: Subtotal
    printTotalRow('Subtotal:', `$ ${subtotal.toLocaleString('es-CL')}`);

    // Fila: Descuento
    if (descuento > 0) {
      printTotalRow(
        `Descuento (${descuento}%):`,
        `- $ ${descuentoMonto.toLocaleString('es-CL')}`
      );
    }

    // Fila: Impuestos
    printTotalRow('Impuestos (19%):', `$ ${impuestos.toLocaleString('es-CL')}`);

    // Fila: Costo envío
    printTotalRow('Costo de envío:', `$ ${envio.toLocaleString('es-CL')}`);

    // === BLOQUE NARANJA DEL TOTAL ===
    const boxWidth = 60;
    const boxHeight = 10;
    const boxY = lineY + 5;

    doc.setFillColor(colorOrg[0], colorOrg[1], colorOrg[2]);
    doc.rect(labelTotX, boxY, boxWidth, boxHeight, 'F');

    doc.setTextColor(255, 255, 255);
    doc.setFontSize(12);
    doc.text(`Total: $ ${total.toLocaleString('es-CL')}`, valueTotX, boxY + 7, {
      align: 'right',
    });

    // === PIE DE PÁGINA ===
    doc.setFontSize(9);
    doc.setTextColor(130);
    doc.text(
      `Documento generado automáticamente por CRM TIC Service — ${new Date().toLocaleString(
        'es-CL'
      )}`,
      105,
      287,
      { align: 'center' }
    );

    doc.save(`Presupuesto_${p.nombre_presupuesto || 'documento'}.pdf`);
  }

  openSendMail() {
    this.dialog.open(MdlSendMail, {
      minWidth: '750px',
      maxHeight: '700px',
      panelClass: 'mat-dlg-class',
      data: {
        mode: 'add', // o 'edit'
        mailData: { // Datos iniciales opcionales
          from: 'usuario@empresa.com',
          asunto: 'Asunto predefinido'
        },
        destinatarios: ['cliente@empresa.com'],
        tipo: 'individual'
      }
    });
  }
}
